import * as yup from 'yup';

export const estadoContratoFormSchema = yup.object({
  nombre: yup.string().required('El campo nombre es requerido')
          .max(200, 'El campo nombre no debe exceder los 200 caracteres'),
  codigo: yup.string().required('El campo codigo es requerido')
          .max(200, 'El campo codigo no debe exceder los 200 caracteres'),
});


export const rejectContratoSchema = yup.object({
        motivo_rechazo_data: yup.string().required('El campo motivo rechazo es requerido'),
        observacion_update_cliente: yup
        .string()
        .required('El campo observacion rechazo tecnico es requerido')
        .min(
        10,
        'El campo observacion rechazo tecnico debe tener al menos 10 caracteres'
        )
        .max(
        200,
        'El campo observacion rechazo tecnico no debe exceder los 200 caracteres'
        ),
        estado_actualizacion: yup
        .string()
        .required('El campo estado orden trabajo es requerido'),
});